(() => {
  if (window.dcTelegramInitialized) return;
  window.dcTelegramInitialized = true;
  const track = (event, extras = {}) => { window.dataLayer = window.dataLayer || []; window.dataLayer.push({event: `dc_tg_${event}`, campaign: 'telegram_welcome', ...extras}); };
  const safeGet = (store, key) => { try { return store.getItem(key); } catch (_) { return null; } };
  const safeSet = (store, key, value) => { try { store.setItem(key, value); } catch (_) {} };
  const params = new URLSearchParams(window.location.search);
  const incomingVariant = params.get('utm_campaign') === 'telegram_welcome' ? params.get('utm_content') : null;
  if (/^[ABC]$/.test(incomingVariant || '')) safeSet(sessionStorage, 'dc_tg_variant_v1', incomingVariant);
  const storedVariant = safeGet(sessionStorage, 'dc_tg_variant_v1');
  const variant = /^[ABC]$/.test(storedVariant || '') ? storedVariant : null;
  document.querySelectorAll('[data-dc-tg-event]').forEach(link => link.addEventListener('click', () => track(link.dataset.dcTgEvent)));
  if (document.querySelector('[data-dc-tg-page]')) track('page_view');
  document.querySelectorAll('[data-dc-tg-form]').forEach(form => form.addEventListener('submit', event => {
    event.preventDefault();
    const input = form.elements.email;
    input.value = input.value.trim();
    const error = form.querySelector('[data-dc-tg-error]');
    if (!form.reportValidity()) { error.textContent = form.dataset.invalid; error.hidden = false; return; }
    error.hidden = true;
    let text = `${form.dataset.message} ${input.value}`;
    if (variant) text += `\n${document.documentElement.lang.startsWith('en') ? 'Campaign source' : 'מקור פעילות'}: TG_${variant}`;
    track('whatsapp_open');
    window.location.assign(`https://wa.me/972522374764?text=${encodeURIComponent(text)}`);
  }));
  const popup = document.querySelector('[data-dc-tg-popup]');
  if (!popup || typeof popup.showModal !== 'function') return;
  const expiryKey = 'dc_tg_popup_until_v1';
  if (Number(safeGet(localStorage, expiryKey)) > Date.now()) return;
  let pages = Number(safeGet(sessionStorage, 'dc_tg_page_count_v1')) || 0;
  safeSet(sessionStorage, 'dc_tg_page_count_v1', String(++pages));
  let savedOverflow = '';
  const dismiss = () => { if (popup.open) popup.close(); safeSet(localStorage, expiryKey, String(Date.now() + 604800000)); };
  popup.querySelectorAll('[data-dc-tg-close]').forEach(button => button.addEventListener('click', dismiss));
  popup.addEventListener('cancel', () => safeSet(localStorage, expiryKey, String(Date.now() + 604800000)));
  popup.addEventListener('close', () => { document.body.style.overflow = savedOverflow; track('popup_close'); });
  popup.addEventListener('click', e => { if(e.target === popup) { const r=popup.getBoundingClientRect(); if(e.clientX<r.left || e.clientX>r.right || e.clientY<r.top || e.clientY>r.bottom) dismiss(); } });
  popup.querySelector('[data-dc-tg-popup-cta]').addEventListener('click', () => { track('popup_click'); safeSet(localStorage, expiryKey, String(Date.now() + 604800000)); });
  let attempts = 0;
  const show = () => {
    if (Number(safeGet(localStorage, expiryKey)) > Date.now()) return;
    const otherModal = [...document.querySelectorAll('dialog[open], [role="dialog"], [aria-modal="true"]')].some(el => el !== popup && !el.closest('details:not([open])') && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden' && getComputedStyle(el).opacity !== '0');
    if (document.hidden || otherModal || document.body.style.overflow === 'hidden') { if(++attempts < 12) setTimeout(show, 5000); return; }
    savedOverflow = document.body.style.overflow;
    popup.showModal(); document.body.style.overflow = 'hidden'; track('popup_view');
  };
  setTimeout(show, pages >= 2 ? 12000 : 30000);
})();
